import React, { useEffect } from "react";
import HomeSearch from "../components/HomeSearch";
import { useDispatch } from "react-redux";
import { clearSearchResults } from "../actions/flightAction";
import Offer from "../components/Offer";

export default function Dashboard() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearSearchResults());
  }, []);
  return (
    <>
      <HomeSearch />

    </>
  );
}
